import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import Icon from '@mui/material/Icon';
import withStyles from '@mui/styles/withStyles';

const style = theme => ({
  icon: {
    marginBottom: theme.spacing(1 / 2),
    marginRight: theme.spacing(1 / 2),
  },
  option: {
    paddingBottom: 0,
    paddingTop: theme.spacing(2),
  },
});

const renderSvgIcon = component => React.createElement(component);

const FlagIcon = (props) => {
  const {
    classes, country, showingName, ...rest
  } = props;
  const details = [`+${country.dialCode}`];
  if (showingName) {
    details.push(country.name);
  }

  return (
    <MenuItem {...rest} className={classes.option}>
      <Icon className={classes.icon}>
        {renderSvgIcon(country.flag)}
      </Icon>
      {details.join(' ')}
    </MenuItem>
  );
};

FlagIcon.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  country: PropTypes.instanceOf(Object).isRequired,
  showingName: PropTypes.bool,
};

FlagIcon.defaultProps = {
  showingName: false,
};

export default withStyles(style)(FlagIcon);
